import React from 'react'
import HeaderSix from '../header/HeaderSix';
import BannerEight from '../elements/BannerEight';
import ServiceFour from '../elements/ServiceFour';
import AboutSix from '../elements/AboutSix';
import CounterTwo from '../elements/CounterTwo';
import PortfolioSix from '../elements/PortfolioSix';
import BrandTwo from '../elements/BrandTwo';
import FooterSix from '../footer/FooterSix';



function HomeEight() {
    return (
        <div>
            
    
            <div className="index-Five">
                <HeaderSix/>
                <main>
                    <BannerEight/>
                    <ServiceFour/>
                    <AboutSix/>
                    <CounterTwo/>
                    <PortfolioSix/>
                    <BrandTwo/>
                    <FooterSix/>

                </main>
            </div>
    

        </div>
    )
}

export default HomeEight